module.exports = __webpack_public_path__ + "static/media/1_19.af49b8d6.png";